export const ANOMALOUS_SPACE_VENUE_ID = '660e8400-e29b-41d4-a716-446655440002';

/** Display overrides when API contact_name is stale or incorrect. */
export const VENUE_CONTACT_NAME_OVERRIDES = {
  [ANOMALOUS_SPACE_VENUE_ID]: 'Nina Culley',
};

/** Apply public-facing contact name overrides to raw or transformed venue records. */
export function applyVenueContactOverrides(venue) {
  if (!venue || typeof venue !== 'object') return venue;

  const id = String(venue.id ?? venue.venue_id ?? '').trim();
  const override = VENUE_CONTACT_NAME_OVERRIDES[id];
  if (!override) return venue;

  return {
    ...venue,
    contact_name: override,
    contact: override,
  };
}
